import type { i18n } from "i18next";
import { en, es } from "zod/v4/locales";

export const getZodLocale = (i18nLocale: i18n["language"]) => {
	switch (i18nLocale) {
		case "en":
			return en;
		case "es":
			return es;
		default:
			return en;
	}
};
